/**
 * Created by Admin on 26.02.2018.
 */
import React, { FC, ReactNode } from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core'

type TabTileProps = {
  tab: {
    name: string
    icon: ReactNode
    description: string
    phrasesNumber: string
  }
  classes: any
  expanded: boolean
  button: any
  detailsStyle: any
  onChange: () => void
}

export const TabTile: FC<TabTileProps> = ({ classes, tab, expanded, onChange, children, button, detailsStyle }) => (
  <ExpansionPanel className={classes.flowExp} expanded={expanded} onChange={onChange}>
    <ExpansionPanelSummary className={`${classes.mainWrap} summary`} expandIcon={<ExpandMoreIcon />}>
      <div className={classes.wrapHeader}>
        <div
          style={{
            marginRight: 24,
            display: 'flex',
            alignItems: 'center',
          }}>
          {tab.icon}
        </div>
        {tab.name && tab.phrasesNumber ? (
          <div className={classes.wrapNameAndPhrases}>
            <p className={classes.name}>{tab.name}</p>
            <p className={classes.description}>{tab.phrasesNumber} phrases</p>
          </div>
        ) : (
          <div style={{ maxWidth: '100%' }}>
            <p className={classes.name}>{tab.name}</p>
            <p className={classes.description}>{tab.description}</p>
          </div>
        )}
        {button && (
          <div style={{ marginLeft: 'auto', alignSelf: 'center' }} onClick={e => e.stopPropagation()}>
            {button}
          </div>
        )}
      </div>
    </ExpansionPanelSummary>
    <ExpansionPanelDetails style={detailsStyle || { display: 'block', padding: '0 0 24px' }}>
      {children}
    </ExpansionPanelDetails>
  </ExpansionPanel>
)
